import Layout from "../../components/shared/layout/layout";
import Seo from "../../components/shared/seo/seo";

export default function Agb(){
    return (
        <Layout>
            <Seo title="AGB" description="Allgemeine Geschäftsbedingungen des Weinguts Gisperg." path="/agb" />
            <section className="no_fill small background_light">
                <h1>AGB's</h1>
                <div className="col-8 left">
                    <p>
                    Geltung
                    </p>
                    <p>
                    Soweit nicht ausdrücklich Gegenteiliges vereinbart wurde, gelten ausschließlich unsere Allgemeinen Geschäftsbedingungen. Allgemeine Geschäftsbedingungen oder dergleichen unseres Vertragspartners werden nicht Vertragsbestandteil, auch nicht subsidiär. Mit der Abgabe einer Bestellung erklärt sich der Kunde mit diesen Allgemeinen Geschäftsbedingungen einverstanden.
                    </p>
                    <p>
                    Angebot & Vertragsabschluss
                    </p>
                    <p>
                    Die Darstellung unserer Produkte in unserem Onlineshop und alle Angebote in unseren Preislisten, Newslettern, Broschüren oder Werbematerialien stellen kein rechtlich bindendes Angebot, sondern eine unverbindliche Aufforderung zur Bestellung von Waren dar. Irrtümer vorbehalten.
                    </p>
                    <p>
                    Die Bestellung des Kunden stellt ein Angebot dar. Ein Vertrag kommt erst nach Annahme unsererseits zustande. Der Kunde wird von unserer Annahme per E-Mail verständigt. Eine Bestellung ist nur möglich, wenn alle im Bestellformular mit * bezeichneten Pflichtfelder ausgefüllt sind. Fehlen Angaben oder können wir der Bestellung aus sonstigen Gründen nicht nachkommen, erhält der Kunde eine Fehlermeldung. Vor dem endgültigen Abschicken der Bestellung erhält der Kunde die Möglichkeit, seine Bestellung zu korrigieren. Unterstützende Detailinformationen erhält der Kunde direkt im Zuge des Bestellvorganges. Sobald der Bestellvorgang abgeschlossen ist, wird der Kunde darüber durch ein Infofenster „Ihre Bestellung ist eingegangen und wird nun bearbeitet. “ benachrichtigt. Dies stellt unsererseits noch keine Annahme des Angebots des Kunden dar.
                    </p>
                    <p>
                    Wenn die Bestellung bei uns eingelangt ist, wird der Kunde, über die von ihm bekannt gegebene E-Mail-Adresse vom Eingang seiner Bestellung verständigt. Diese Verständigung stellt unsererseits noch keine Annahme des Angebots des Kunden dar .
                    </p>
                    <p>
                    Wir behalten uns das Recht vor, Bestellungen ohne Angabe von Gründen zu kürzen, um allen Kunden den Erwerb unserer Weine zu ermöglichen. Für die Lieferung sind nur unsere aktuellen Liefer- und Zahlungsbedingungen maßgebend. Abweichende Vereinbarungen sind nur gültig, wenn sie von uns schriftlich bestätigt werden.
                    </p>
                    <p>
                    Aufgrund der beschränkten Mengen einzelner Jahrgänge kann während Ihrer Bestellung eine Ausverkaufssituation eintreten. Verfügbarkeit freibleibend!
                    </p>
                    <p>
                    Sinngemäß gilt dasselbe für Bestellanfragen per E-Mail, Telefon, Fax oder Brief. Änderungen oder Fehler auf unserer Website oder dort publizierter Downloads und in unseren Druckdokumenten, Angaben zu Weinen oder Preisen (zB. Onlineshop) vorbehalten.
                    </p>
                    <p>
                    Kundenseitige Änderungswünsche oder Fehler, welche nach Abschluss des Bestellvorganges bemerkt werden, können via Änderungsanfrage an wein@weingut-gisperg.at unter Angabe der Bestellnummer eingebracht werden. Die Möglichkeit der Durchführung muss allerdings geprüft werden.
                    </p>
                    <p>
                    Datenverarbeitung & Kundendaten
                    </p>
                    <p>
                    Der Kunde stimmt ausdrücklich zu, dass seine bei der Bestellung und/oder Registrierung bekannt gegebenen persönlichen Daten unter Beachtung der Bestimmungen des Datenschutzgesetzes gespeichert und verarbeitet werden. Diese Daten werden zur Erfüllung von gesetzlichen Vorschriften, zur Abwicklung des Zahlungsverkehrs, der Kundenpflege sowie zu Marketingzwecken verwendet. Ferner stimmt der Kunde ausdrücklich zu, von uns und von Dritten Zusendungen zu Werbezwecken zu erhalten. Diese Zustimmung kann jederzeit per E-Mail widerrufen werden. Bitte lesen Sie dazu auch unsere Datenschutzbestimmungen.
                    </p>
                    <p>
                    Fälligkeit
                    </p>
                    <p>
                    Die Bestellung kommt mit Bestätigung der Bestellung (per E-Mail oder per Briefsendung) unsererseits gültig zustande. Bei Schreib-, Druck- und Rechenfehlern auf der Website sind wir zum Rücktritt berechtigt.
                    </p>
                    <p>
                    Lieferung & Versand
                    </p>
                    <p>
                    Aufgrund logistischer Gegebenheiten sind ausschließlich Bestellungen in 6er oder 12er Schritten möglich. Die einzige Ausnahme davon ist der Versand von Magnum-Flaschen. Dieser erfolgt aufgrund der Flaschengröße im 1er Magnum-Karton.
                    </p>
                    <p>
                    Die angegebenen Preise beziehen sich auf den Versand im 12er Karton in Österreich bzw. Deutschland. Dies ist bei Bestellungen von 12 Flaschen (und mehr) der Fall. Da beim Versand im 6er Karton höhere Kosten anfallen, wird beim Versand eines 6er Kartons ein Aufpreis von € 4,00 innerhalb Österreichs sowie ein Aufpreis von € 6,00 nach Deutschland pro Karton verrechnet.
                    </p>
                    <p>
                    Versandkosten in andere Länder erhalten Sie auf Anfrage.
                    </p>
                    <p>
                    Der Versand erfolgt via Paketdienst. Wenn Zustellungen aufgrund falscher oder unvollständiger Daten nicht möglich sind oder hinterlegte Pakete nicht abgeholt und daher zurückgeschickt werden, behalten wir uns das Recht vor, den erneuten Versand kostenpflichtig in Rechnung zu stellen.
                    </p>
                    <p>
                    Transportschäden
                    </p>
                    <p>
                    Für Schäden und Beeinträchtigungen, welche während des Transportes entstehen, garantieren wir Ihnen vollständigen Ersatz unter folgenden Bedingungen:
                    </p>
                    <p>
                    –	Die eintreffende Ware ist sofort auf Ordnungsmäßigkeit und Vollständigkeit zu überprüfen.
                    </p>
                    <p>
                    –	Beschädigte Ware ist nach Möglichkeit nicht anzunehmen und dem Fahrer direkt zu retournieren.
                    </p>
                    <p>
                    –	Eine Beanstandung der Ware ist innerhalb von 8 Tagen mitzuteilen.
                    </p>
                    <p>
                    –	Jegliche Beanstandungen sind vom Transportunternehmen bestätigen zu lassen.
                    </p>
                    <p>
                    Vorbehalte
                    </p>
                    <p>
                    Die gelieferten Waren bleiben bis zur vollständigen Bezahlung unser Eigentum. Übereignung und Pfändung sind bis zur Bezahlung unzulässig. Der Käufer ist verpflichtet, uns bei etwaigen Zugriffen zu verständigen.
                    </p>
                    <p>
                    Zahlungsarten / Fälligkeit
                    </p>
                    <p>
                    Der Kunde verpflichtet sich bei Vertragsabschluss zur vollständigen Bezahlung des Kaufpreises innerhalb 4 Tagen nach Rechnungserhalt. Diese wird an die angegebene E-Mail-Adresse zugestellt. Die Lieferung der Ware erfolgt nach Eingang des vollständigen Rechnungsbetrages auf unserem Bankkonto. Jegliche Abzüge, wie z.B. Skonti sind nicht gestattet und führen zu einer Einforderung des offenen Differenzbetrages. In Zahlungsverzugsfällen behalten wir uns vor Verzugs- bzw. Mahnspesen zu verrechnen.
                    </p>
                    <p>
                    Preise
                    </p>
                    <p>
                    Die Preise verstehen sich in Euro pro Flasche, inklusive aller gesetzlichen Abgaben und Steuern (Umsatzsteuer, Sektsteuer), Transportkosten beim Versand im 12er Karton innerhalb Österreich und nach Deutschland  (wie im Punkt Lieferung & Versand angegeben). Preisänderungen und Irrtümer vorbehalten!
                    </p>
                    <p>
                    Gewährleistungen & Schadensersatz
                    </p>
                    <p>
                    Reklamationen auf Grund gesetzlicher Gewährleistungsansprüche können bei folgender Adresse geltend gemacht werden:  Gisperg Johann & Mitbesitzer Ges.n.b.R. Hauptstraße 14, 2524 Teesdorf, Tel.: +43 (0) 2253 /81464;
                    </p>
                    <p>
                    Für korkkranke Weine kann entsprechend international üblicher Usancen kein Ersatz geleistet werden. Handelsübliche oder geringfügige, technisch bedingte Abweichungen der Qualität, Quantität, Farbe, Größe, des Gewichtes, der Ausrüstung oder des Designs stellen weder Gewährleistungsmängel noch Nichterfüllung des Vertrages dar. Enstehen Mängel nach Übergabe der Ware neu, handelt es sich dabei um keinen Gewährleistungsfall (z.B. Mängel durch ungeeignete Lagerung). Etwaige Unwirksamkeiten einzelner Bestimmungen berühren die Wirksamkeit der übrigen Bestimmungen nicht.
                    </p>
                    <p>
                    Jugendschutz
                    </p>
                    <p>
                    Die Abgabe und die Zustellung von alkoholischen Getränken erfolgt en nur an Personen über 18 Jahren. Mit Aufgabe der Bestellung versichert der Kunde, dass er bzw. der Empfänger der Ware älter als 18 Jahre ist. Zur Einhaltung der gesetzlichen Vorschriften sind wir berechtigt, die Ware erst nach Legitimation durch einen amtlichen Lichtbildausweis zu übergeben. Im Falle der berechtigten Verweigerung der Übergabe ist der Kunde zum Ersatz des tatsächlich entstandenen Schadens verpflichtet.
                    </p>
                    <p>
                    Widerrufsrecht
                    </p>
                    <p>
                    Unternehmern steht kein Rücktrittsrecht/Widerrufsrecht zu.
                    </p>
                    <p>
                    Für Verbraucher im Sinne des Konsumentenschutzgesetzes, die eine Bestellung im Wege des Fernabsatzes getätigt haben, gilt:
                    </p>
                    <p>
                    Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
                    </p>
                    <p>
                    Um dieses Widerrufsrecht auszuüben, muss der Käufer uns, der Gisperg Johann & Mitbesitzer GesnbR, Hauptstraße 14, 2524 Teesdorf, Tel.: +43 (0) 2253 / 81464 , E-Mail: wein@weingut-gisperg.at, mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über seinen Entschluss, den Vertrag zu widerrufen, informieren.
                    </p>
                    <p>
                    Folgen des Widerrufs
                    </p>
                    <p>
                    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Nicht gewünschte Ware kann, so sie noch nicht angebrochen bzw. beschädigt ist, auf Kosten des Käufers zurückgesendet werden. Die Rücksendung muss im Originalkarton oder einem gleichwertigen Versandkarton für Glasflaschen erfolgen.
                    </p>
                    <p>
                    Zur Wahrung der Widerrufsfrist reicht es aus, dass der Käufer die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absendet. Rücksendekosten sind nach der Umsetzung der Verbraucherrechterichtlinie grundsätzlich vom Verbraucher zu tragen.
                    </p>
                    <p>
                    Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.
                    </p>
                    <p>
                    Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.
                    </p>
                    <p>
                    Kein Rücktrittsrecht besteht auch bei (§ 18 FAGG) Waren, die nach Kundenspezifikation angefertigt wurden oder auf die persönlichen Bedürfnisse des Kunden zugeschnitten sind;
                    </p>
                    <p>
                    Muster-Widerruf
                    </p>
                    <p>
                    –	An
                    </p>
                    <p>
                    [hier ist der Name, die Anschrift und gegebenenfalls die Faxnummer und E-Mail-Adresse des Unternehmers durch den Unternehmer einzufügen]
                    </p>
                    <p>
                    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
                    </p>
                    <p>
                    –	Bestellt am (*)/erhalten am (*)
                    </p>
                    <p>
                    –	Name des/der Verbraucher(s)
                    </p>
                    <p>
                    –	Anschrift des/der Verbraucher(s)
                    </p>
                    <p>
                    –	Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
                    </p>
                    <p>
                    –	Datum
                    </p>
                    <p>
                    (*) Unzutreffendes streichen.
                    </p>
                    <p>
                    Copyright
                    </p>
                    <p>
                    Texte, Bilder, Animationen und Fotos auf unserer Website sind urheberrechtlich geschützt und dürfen nicht kopiert oder verwendet werden.
                    </p>
                    <p>
                    Gerichtsstand
                    </p>
                    <p>
                    Auf diesen Vertrag ist österreichisches materielles Recht anzuwenden, die Anwendbarkeit des UN-Kaufrechtes wird ausgeschlossen. Vertragssprache ist Deutsch.
                    </p>
                    <p>
                    Zur Entscheidung aller aus diesem Vertrag entstehenden Streitigkeiten ist das in 2524 Teesdorf sachlich zuständige Gericht örtlich zuständig. Wir haben jedoch das Recht, auch am allgemeinen Gerichtsstand des Vertragspartners zu klagen.
                    </p>
                    <p>
                    Für den Inhalt verantwortlich (gemäß E-Commerce-Gesetz 2002):
                    </p>
                    <p>
                    Gisperg Johann & Mitbesitzer Ges.n.b.R.<br/><br/>
                    Hauptstraße 14<br/><br/>
                    2524 Teesdorf<br/><br/>
                    Tel.: +43 (0) 2253 /81464<br/><br/>
                    Fax: +43 (0) 2253/ 81464-50<br/><br/>
                    E-Mail: wein@weingut-gisperg.at<br/><br/>
                    UID-Nummer: ATU 17532908<br/><br/>
                    Handelsgericht: Baden<br/><br/>
                    </p>
                </div>
            </section>
        </Layout>
    );
}